import { Directive, TemplateRef, ViewContainerRef, Input, OnInit } from '@angular/core';
import { ProductCodeQuery } from '@fgb/core';
import { take } from 'rxjs';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[inProductCode]',
})
export class InProductCodeDirective implements OnInit {
  private _flatProductCodes: string[] = [];

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private productCodeQuery: ProductCodeQuery
  ) {}

  @Input() set inProductCode(productCodes: string[] | string[][]) {
    let flatProductCodes: string[] = [];
    /** If productCodes are passed as a multidimensional array, flatten them into a single array */
    if (productCodes[0] !== undefined && productCodes[0].constructor === Array) {
      flatProductCodes = (productCodes as string[][]).reduce((accumulator, value) => accumulator.concat(value), []);
    } else {
      flatProductCodes = productCodes as string[];
    }
    this._flatProductCodes = flatProductCodes;
  }

  ngOnInit(): void {
    this.createView();
  }

  createView(): void {
    this.productCodeQuery
      .selectCurrentUserIsProductCode(this._flatProductCodes)
      .pipe(take(1))
      .subscribe((p) => {
        this.viewContainer.clear();
        if (p) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }
}
